<div class="loader-container" *ngIf="isLoaderActive">
    <div class="box-container">
        <div class="box box1"></div>
        <div class="box box2"></div>
        <div class="box box3"></div>
        <div class="box box4"></div>
        <div class="box box5"></div>
    </div>
</div>
